<script>
  export let text = null;
</script>

<style>
  h2 {
    text-transform: uppercase;
    letter-spacing: 0.08rem;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px;
  }

  @media only screen and (min-width: 600px) {
    h2 {
      font-size: 22px;
    }
  }
</style>

{#if text}
  <h2>{text}</h2>
{:else}
  <h2>
    <slot />
  </h2>
{/if}
